import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div<any>`
  width: ${(p) => p.w};
  box-sizing: content-box;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${(p) => p.p};
  grid-area: ${(p) => p.gridAreaName};
  border-radius: ${(p) => p.borderRadius};
  background-color: ${(p) => p.backgroundColor};
  transition: all 0.3s;
  ${(p) =>
    p.iconFillColor &&
    `
    & g[mask] rect {
      fill: ${p.iconFillColor};
    }
  `}
`;

const SVGIconHolder = ({
  children,
  iconWidth = '18px',
  padding = '0em',
  gridAreaName = '',
  borderRadius = '0px',
  backgroundColor = 'transparent',
  iconFillColor,
  ...rest
}: any) => {
  return (
    <Wrapper
      w={iconWidth}
      p={padding}
      gridAreaName={gridAreaName}
      borderRadius={borderRadius}
      backgroundColor={backgroundColor}
      iconFillColor={iconFillColor}
      {...rest}
    >
      {children}
    </Wrapper>
  );
};

export default SVGIconHolder;
